import styled from 'styled-components'

export const Container = styled.div`
  .sexoRadios {
    margin-top: -7px;
    border: rgb(201, 201, 201) solid 1px;
    border-radius: 3px;
    padding-left: 15px;
  }

  .sexoRadios legend {
    margin-left: 1px;
    font-size: 12px;
    margin-bottom: -10px;
  }

  .uploadImg {
    display: flex;
    min-height: 200px;
    max-height: 200px;
    border: 1px dashed rgb(201, 201, 201);
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: 0.5s;
  }

  .uploadImg:hover {
    border: 1px dashed #5da57d;
    color: #5da57d;
  }

  .ant-drawer-header {
    padding: 0 !important;
  }

  .ant-drawer-body {
    padding: 5px !important;
    overflow: hidden;
  }

  .site-drawer-render-in-current-wrapper {
    position: relative;
  }

  .log-user{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    /* height: 32px; */
    margin-top: -25px;
    /* background-color: rebeccapurple; */
}


`
